module.exports = __webpack_public_path__ + "img/flame.5013e6bc.svg";